// React
import React, { useState, useEffect, useContext } from "react";

// Types
import { ProductBuilderSelection } from "../../../../types/ProductBuilderTypes";

import { BffDataContext } from "../../../../contexts/BffDataContextProvider";
import { ProductContext } from "../../../../contexts/ProductContextProvider";
import { PageStaticDataContext } from "../../../../contexts/PageStaticDataContextProvider";
import { ProductOption, ProductOptionChangedEvent } from "@vp/product-options-ui";
import PageConfig from "../../../../utils/PageConfig";
import { mapMpvValueToProductOptionChoice } from "../../utils/productOptionChoice";

interface ColorSwatchSelectorProps {
  selectionData: ProductBuilderSelection;
  showIncompatibleValues: boolean;
  disabled: boolean;
  onChange: (value: string | null) => void;
  selectorIndex: number;
}

const ColorSwatchSelector = (props: ColorSwatchSelectorProps) => {
  const [selectedValueName, setSelectedValueName] = useState("");
  const { compatibleValues, attributeConstraints, prices } = useContext(BffDataContext);
  const { locale } = useContext(PageStaticDataContext);
  const { selections = {} } = useContext(ProductContext);

  useEffect(() => {
    if (!selections[optionKey]) {
      setSelectedValueName("");
    } else {
      const currentValue = option.options?.find(value => value.key === selections[optionKey])?.name;
      setSelectedValueName(currentValue ?? "");
    }
  }, [selections]);

  const option = props.selectionData.property;
  const optionKey = option.key;

  if (!option || !compatibleValues[optionKey] || compatibleValues[optionKey].length === 0) {
    return <></>;
  }

  const choices = (option.options || []).map(optionValue =>
    mapMpvValueToProductOptionChoice({
      optionValue,
      option,
      selections,
      compatibleValues,
      attributeConstraints,
      showIncompatibleValues: props.showIncompatibleValues,
      dictionary: {
        outOfStockText: "",
        selectorIncompatibleText: "",
        newCalloutText: "",
        recommendedText: "",
      },
    })
  );

  return (
    <ProductOption
      productOption={{
        key: optionKey,
        name: option.name,
        style: "color-swatch",
        selectedKey: selections[optionKey],
        choices,
      }}
      skin="standard"
      tenant={PageConfig.tenant}
      locale={locale}
      currency={Object.values(prices || {})?.[0]?.currency ?? ""}
      fractionDigits={Object.values(prices || {})?.[0]?.fractionDigits ?? 2}
      onChanged={(event: ProductOptionChangedEvent) => {
        const { choiceKey } = event;
        props.onChange(choiceKey);

        const selectedMpvValue = option.options?.find(v => v.key === choiceKey);
        setSelectedValueName(selectedMpvValue?.name || "");
      }}
      showIncompatibleChoices={props.showIncompatibleValues}
      priceDisplayMode={"none"}
    />
  );
};

export default ColorSwatchSelector;
